import { CarouselItem } from '../../../models/item';
import { html } from 'lit-html';
import { each } from '../../../component';
import { LeftSidePromotionDisplay } from './promotion_display';
import { ItemImage, ItemLink, PriceArea } from '../../common/item_cassette/price_image_link';
import { getAssetsUrlBase } from '../../../models/common/static_resource_util';

let isUserLogin: boolean;
/**
 * カルーセルの商品エリア、RR左サイド版
 * @param carouselItems カルーセル商品リスト
 */
export const CarouselItemsLeftSide = (carouselItems: CarouselItem[], isLogin: boolean, carouselId: string) => {
  isUserLogin = isLogin;
  const lineNumber = 5;
  const itemsList: CarouselItem[][] = [];
  while (carouselItems.length > 0) {
    itemsList.push(carouselItems.splice(0, lineNumber));
  }

  return html`
    <div class="o-menuBar_itemcardListBody js-carousel_multiBtn">
      <div class="o-carousel js-lazy-img js-carousel -navRecommend" id="${carouselId}">
        ${CarousePagingLeftSide()}
        <div
          class="swiper-container js-carousel-body"
          data-type="navRecommend"
          data-perview="1"
          data-space="24"
        >
          <div class="swiper-wrapper">
            ${each(itemsList, CarouselItemListAreaLeftSide)}
          </div>
        </div>
        ${CarousePagingLeftSide()}
      </div>
    </div>
  `;
};

const CarouselItemListAreaLeftSide = (itemsList: CarouselItem[]) => {
  return html`
    <div class="o-carousel_slide swiper-slide js-carousel_slide">
      <div class="o-carousel_slideinner">
        ${each(itemsList, CarouselItemAreaLeftSide)}
      </div>
    </div>
  `;
};

/**
 * カルーセル商品単品、RR左サイド版
 * @param carouselItem カルーセル-商品情報
 */
const CarouselItemAreaLeftSide = (carouselItem: CarouselItem) => html`
  <div class="m-simpleitemcard -horizontal">
    ${LeftSidePromotionDisplay(carouselItem.promotionDisplayType)}
    <div class="m-simpleitemcard_inner">
      <div class="m-simpleitemcard_body">
        <div class="m-simpleitemcard_name">
          <p class="a-text">
            <a
              href=${ItemLink(
                carouselItem.supplierId,
                carouselItem.itemCode,
                carouselItem.isVariation,
                carouselItem.rrLinkUrl
              )}
              data-maxline="3"
              title="${carouselItem.itemName}"
              class="a-textlink u-maxline"
              >${carouselItem.itemName}
            </a>
          </p>
        </div>
        ${PriceArea(
          carouselItem.salesPriceTaxInclude,
          carouselItem.isVariation,
          carouselItem.isMedical,
          isUserLogin
        )}
      </div>
      <div class="m-simpleitemcard_section">
        <a
          href=${ItemLink(carouselItem.supplierId, carouselItem.itemCode, carouselItem.isVariation, carouselItem.rrLinkUrl)}
          title="${carouselItem.itemName}"
          class="m-simpleitemcard_link"
        >
          <div class="m-simpleitemcard_img">
            <div class="a-img -radius">
              <span class="a-img_imgWrap">
                ${ItemImage(carouselItem.imageUrl, carouselItem.itemName)}
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
`;

/**
 * カルーセル商品ページング、RR左サイド版
 */
const CarousePagingLeftSide = () => html`
  <div class="o-carousel_btns">
    <button class="m-btn -small o-carousel_prev js-carousel_prev" type="button">
      <span class="m-btn_inner">
        <span class="m-btn_text">
          <span class="a-icon -size8 -vertical">
            <img class="a-icon_img" src="${getAssetsUrlBase() + "images/icon_angle_left_black.svg"}" alt="" width="8" height="8" />
          </span>
        </span>
      </span>
    </button>
    <button class="m-btn -small o-carousel_next js-carousel_next" type="button">
      <span class="m-btn_inner">
        <span class="m-btn_text">
          <span class="a-icon -size8 -vertical">
            <img class="a-icon_img" src="${getAssetsUrlBase() + "images/icon_angle_right_black.svg"}" alt="" width="8" height="8" />
          </span>
        </span>
      </span>
    </button>
  </div>
`;
